module.exports = __webpack_public_path__ + "img/i-hover.84aa9b94.svg";